import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeObj, judgeArr, dealValueShow, thousandBitSeparator, dealCarNum } from '@/shared/functions';
const initState = {
    items: [],
    totalNum: 0,
    currentIndex: 1,
    pageSize: 20,
    tableLoading: false,
    searchData: {},
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 初始化加载数据
         */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { id: bankAccount } = rootState.router.query;
                const { currentIndex, pageSize, searchData } = state;
                const _param = Object.assign({ bankAccount, currentIndex, pageSize }, searchData);
                this.SET_STATE({ tableLoading: true });
                const result = { totalNum: 0, items: [] };
                Api.finance.selectAccountDetailList(_param).then((res) => {
                    console.log('selectAccountDetailList res', res);
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        let dealMoney = parseFloat(v.moneyY);
                        // 如果是支出且金钱大于0则将dealMoney改为负值
                        v.type === 1 && dealMoney && dealMoney > 0 ? dealMoney = -dealMoney : dealMoney = v.moneyY;
                        const _item = {
                            key: i,
                            number: dealCarNum(currentIndex * 20 - 19 + i),
                            createTime: dealValueShow(v.createTime),
                            statusStr: dealValueShow(v.statusStr),
                            moneyY: dealValueShow(thousandBitSeparator(dealMoney)),
                            balanceY: dealValueShow(thousandBitSeparator(v.balanceY)),
                            detailTypeStr: dealValueShow(v.detailTypeStr),
                            typeStr: dealValueShow(thousandBitSeparator(v.typeStr)),
                            sourceStr: dealValueShow(thousandBitSeparator(v.sourceStr), '', '/'),
                            shopName: dealValueShow(v.shopName, '', '/'),
                            shopCode: v.shopCode,
                            remark: dealValueShow(v.remark),
                        };
                        return _item;
                    });
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.SET_STATE(Object.assign({}, result));
                    this.SET_STATE({ tableLoading: false });
                });
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET_PAGE_CURRENT(state, payload) {
            state.currentIndex = payload;
        },
    },
});
